import { Empty } from 'antd';

import { PageTitle, PageWrapper } from '@style/pages/page.style';

import { Table } from '@atom/table/table';

import { usePaymentHistory } from './payment-history.hook';
import { paymentHistoryOptions } from './payment-history.options';

export const PaymentHistoryPage = () => {
  const { data, isLoading } = usePaymentHistory();

  return (
    <PageWrapper>
      <PageTitle>Payment History</PageTitle>
      <Table
        columns={paymentHistoryOptions}
        dataSource={data}
        loading={isLoading}
        locale={{ emptyText: <Empty description='No billings yet' image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
        pagination={false}
        rowKey='id'
      />
    </PageWrapper>
  );
};
